import React, { useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import Backbutton from "../../assets/images/white-back-button.png";

const BackButton =  React.memo(({ show }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  if (!show) return null;

  const handleBack = () => {
    setCamefrompreviospage(false);
    navigate(-1);
  };


  return (
    <button className="create-meeting-button Mom-btn back-btn" onClick={handleBack}>
     <img
          // @ts-ignore
          src={Backbutton}
          alt="" className="new-backbutton" 
        />
    </button>
  );
});

export default BackButton;
